import { styled, Typography } from '@mui/material';
import { IProduct } from 'modules/inventory/common/interfaces';
import { useTranslation } from 'react-i18next';

type ProductRulesProps = {
  data: IProduct;
};

type Rules = {
  label: string;
  color: string;
  value?: any;
};

const getRules = (data: IProduct): Rules[] => {
  const rules = [];
  if (data?.rules?.limitByAge) rules.push({ label: 'olderAge', color: 'error' });
  if (data?.rules?.needCi) rules.push({ label: 'product:CI', color: 'error' });
  if (data?.rules?.limitByOrder) {
    rules.push({ label: 'limitByOrder', color: 'error', value: { limit: data?.rules?.limitByOrder } });
  }
  if (data?.rules?.freeShipping) rules.push({ label: 'freeShipping', color: 'success.main' });
  if (data?.rules?.onlyOnDemand) rules.push({ label: 'onDemand', color: 'error' });
  return rules;
};

export const RulesTags = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
  alignItems: 'center',
  '.MuiTypography-root:not(:last-child)': {
    '&:after': {
      content: '","',
      marginRight: '8px',
    },
  },
}));

const ProductRules = ({ data }: ProductRulesProps) => {
  const { t } = useTranslation('offerOrder');

  const rules = getRules(data);
  if (!rules.length) return <></>;

  return (
    <RulesTags>
      {rules.map((r) => (
        <Typography key={r.label} color={r.color} fontSize={'small'}>
          {t(r.label, r.value)}
        </Typography>
      ))}
    </RulesTags>
  );
};

export default ProductRules;
